//提取IP/生成IP
<template>
  <div class="tqip width1200">
    <p class="title">生成提取IP链接</p>

    <div class="form">
      <!--<div class="group d-flex d-flex-aic">
        <label for="tqlx">请选择提取类型</label>
        <div class="group-right">
          <input type="text" id="tqlx" class="tqlx">
          &lt;!&ndash;<button class="btn1">领取每日免费IP</button>&ndash;&gt;
        </div>
      </div>-->

      <!--<div class="group">
        <div class="zhgk d-flex d-flex-aic d-flex-jc-sb">
          <label for="tqlx">账户概况</label>
          <span>获取不扣费，使用才扣费</span>
        </div>
        <div class="zhgk-list d-flex">
          <div class="zhgk-list-info">
            <p>套餐包余量详情 查看更多余额包</p>
            <p>0</p>
          </div>
          <div class="zhgk-list-info">
            <p>账户总余额</p>
            <p>0</p>
          </div>
          <button>立刻充值</button>
        </div>
      </div>-->

      <div class="group d-flex d-flex-aic d-flex-aifs">
        <label for="ipxy">IP协议</label>
        <div class="group-right d-flex d-flex-fw-w">
          <div
            class="group-item"
            v-for="(item, index) in ipxy"
            :key="index"
            @change="formChange('ipxy', item.id)"
          >
            <input
              type="radio"
              :checked="item.id == params.ipxy ? true : false"
              name="ipxy"
              :id="`ipxy_${index}`"
            />
            <label :for="`ipxy_${index}`">{{ item.text }}</label>
            <!--<div class="group-form" v-show="index == 3 && params.ipxy == 3">
              <div class="group-form-box">
                <div class="row d-flex">
                  <label for="username">用户名</label>
                  <input id="username" type="text">
                </div>
                <div class="row d-flex">
                  <label for="password">密码</label>
                  <input id="password" type="text">
                </div>
                <button>修改</button>
              </div>
            </div>-->
          </div>
        </div>
      </div>

      <div class="group d-flex d-flex-aic">
        <label for="tqlx">提取数量</label>
        <div class="group-right d-flex d-flex-aic d-flex-jc-sb">
          <div class="progress-box">
            <slider
              :min="sliderParam.min"
              :max="sliderParam.max"
              :value="count"
              :isDrag="true"
              bgColor="#1da83b"
              @inputData="inputData"
            />
          </div>
          <div class="group-count d-flex-aic">
            <img
              :src="require('@/assets/images/icon15.png')"
              alt=""
              @click="inputChange('del')"
            />
            <input type="text" v-model="count" @input="countChange" />
            <img
              :src="require('@/assets/images/icon16.png')"
              alt=""
              @click="inputChange('add')"
            />
          </div>
        </div>
      </div>

      <!--<div class="group d-flex d-flex-aic  d-flex-aifs">
        <label for="wdsc">稳定使用时长</label>
        <div class="group-right group-right-wdsc d-flex d-flex-fw-w">
          <div class="group-item" v-for="(item, index) in wdsc" :key="index" @change="formChange('wdsc', index)">
            <input type="radio" :checked="index == params.wdsc ? true : false" name="wdsc" :id="`wdsc_${index}`" />
            <label :for="`wdsc_${index}`">{{item.text}}</label>
          </div>
          <div class="group-item">
            <a href="">了解更多></a>
          </div>
        </div>
      </div>-->

      <div class="group d-flex d-flex-aic">
        <label for="sjgs">数据格式</label>
        <div class="group-right d-flex">
          <div
            class="group-item"
            v-for="(item, index) in sjgs"
            :key="index"
            @change="formChange('sjgs', item.id)"
          >
            <input
              type="radio"
              :checked="item.id == params.sjgs ? true : false"
              name="sjgs"
              :id="`sjgs_${index}`"
            />
            <label :for="`sjgs_${index}`">{{ item.text }}</label>
          </div>
        </div>
      </div>

      <div class="group d-flex d-flex-aic d-flex-aifs">
        <label for="fgf">分隔符</label>
        <div class="group-right group-right-more d-flex d-flex-fw-w">
          <div
            class="group-item d-flex"
            v-for="(item, index) in fgf"
            :key="index"
            @change="formChange('fgf', item.id)"
          >
            <input
              type="radio"
              :checked="item.id == params.fgf ? true : false"
              name="fgf"
              :id="`fgf_${index}`"
            />
            <label :for="`fgf_${index}`">{{ item.text }}</label>
            <input type="text" class="other" v-if="index == 4" />
          </div>
        </div>
      </div>

      <div class="group d-flex d-flex-aic d-flex-aifs">
        <label for="dqxz">地区选择</label>
        <div class="group-right group-right-dqxz d-flex d-flex-fw-w">
          <div class="group-item">
            <div class="group-agree d-flex">
              <input type="checkbox" name="dqxz" id="dqxz1" v-model="chooseArea" :value="isProvince"/>
              <label for="dqxz1">省份选择</label>
            </div>
          </div>
          <div class="group-item">
            <div class="group-agree d-flex">
              <input type="checkbox" name="dqxz" id="dqxz2" v-model="chooseArea" :value="isCity"/>
              <label for="dqxz2">城市选择<span class="red">（注：未勾选默认全国混拨）</span></label>
            </div>
          </div>
          <div class="group-item">
            <a href="/smallcity" target="_blank">省份城市代码></a>
          </div>
          <div class="group-item d-flex">
            <select
              class="province"
              v-model="provinceValue"
              @change="provinceChange"
            >
              <option value="">请选择</option>
              <option
                v-for="(item, index) in province"
                :key="index"
                :value="item.value"
              >
                {{ item.label }}
              </option>
            </select>
            <select class="city" v-model="cityValue">
              <option>请选择</option>
              <option
                v-for="(item, index) in city"
                :key="index"
                :value="item.value"
              >
                {{ item.label }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <!--<div class="group d-flex d-flex-aic">
        <label for="dkws">端口位数</label>
        <div class="group-right d-flex">
          <div class="group-item" v-for="(item, index) in dkws" :key="index" @change="formChange('dkws', index)">
            <input type="radio" :checked="index == params.dkws ? true : false" name="dkws" :id="`dkws_${index}`" />
            <label :for="`dkws_${index}`">{{item.text}}</label>
          </div>
        </div>
      </div>-->

      <div class="group d-flex d-flex-aic">
        <label for="ipqc">IP去重</label>
        <div class="group-right d-flex">
          <div
            class="group-item"
            v-for="(item, index) in ipqc"
            :key="index"
            @change="formChange('ipqc', item.id)"
          >
            <input
              type="radio"
              :checked="item.id == params.ipqc ? true : false"
              name="ipqc"
              :id="`ipqc_${index}`"
            />
            <label :for="`ipqc_${index}`">{{ item.text }}</label>
          </div>
        </div>
      </div>

      <div class="group d-flex d-flex-aic">
        <label for="pw">验证模式</label>
        <div class="group-right d-flex">
          <div class="group-item" v-for="(item, index) in pw" :key="index">
            <input
              id="pw"
              type="radio"
              name="pw"
              :value="item.value"
              v-model="params.pw"
            />
            <label>{{ item.text }}</label>
          </div>
        </div>
      </div>

      <!--<div class="group d-flex d-flex-aic">
        <label for="yys">运营商</label>
        <div class="group-right d-flex">
          <div class="group-item" v-for="(item, index) in yys" :key="index" @change="formChange('yys', index)">
            <input type="radio" :checked="index == params.yys ? true : false" name="yys" :id="`yys_${index}`" />
            <label :for="`yys_${index}`">{{item.text}}</label>
          </div>
        </div>
      </div>-->

      <div class="group d-flex d-flex-aic">
        <label for="cns"></label>
        <div class="group-right">

          <div class="group-agree d-flex">
            <input
              type="checkbox"
              :checked="agree"
              :value="agree"
              @click="agree = !agree"
            />
            我同意
            <a href="/bzs" target="_blank" id="popover-bzs">《代理用户安全保证书》</a>
          </div>

          <div class="group-agree d-flex" v-if="show">
            <span class="red"> <b-icon icon="exclamation-circle"></b-icon> 请阅读并同意 《代理用户安全保证书》</span>
          </div>

          <button class="send" @click="generateGetIpLink">生成API链接</button>
        </div>
      </div>
    </div>

    <div class="ip">
      <p class="title d-flex d-flex-aic">
        提取链接
        <img :src="require('@/assets/images/icon13.png')" alt="" />
        <span>(请复制下面的链接地址，在新的浏览器或标签页打开并查看)</span>
      </p>
      <div class="ip-info d-flex">
        <input
          type="text"
          :value="getIpUrl"
          name="sdip"
          disabled
          placeholder="点击上方按钮，生成API链接："
        />
        <b-popover
          :show.sync="copySuccess"
          target="copy-link-btn"
          placement="top"
          triggers="click"
        >
          <strong>复制成功</strong>
        </b-popover>
        <span
          id="copy-link-btn"
          :data-clipboard-text="getIpUrl"
          @click="copyUrl"
          >复制链接</span
        >
        <span @click="openLink">打开链接</span>
      </div>
      <div class="item">
        <div class="item-result">
          <div class="result-note">
            <p>请求参数注释</p>
            <b-table
              striped
              responsive
              :items="itemsParams"
              :fields="fieldsParams"
            ></b-table>
          </div>
        </div>
      </div>
    </div>

    <div class="item">
      <p class="title">返回结果示例</p>
      <div class="item-result">
        <div class="result-json">
          <json-viewer
            class="jsonview"
            :value="jsonData"
            :expand-depth="10"
            :copyable="true"
          >
          </json-viewer>
        </div>
        <div class="result-note">
          <p>结果注释</p>
          <b-table
            striped
            responsive
            :items="itemsNote"
            :fields="fieldsNote"
          ></b-table>
        </div>
        <div class="result-code">
          <p>错误代码</p>
          <b-table
            striped
            responsive
            :items="itemsCode"
            :fields="fieldsCode"
          ></b-table>
        </div>
      </div>
    </div>

    <div class="item">
      <p class="title">使用方法</p>
      <div class="use-way">
        <p>* 生成API链接，调用HTTP GET请求即可返回所需的IP结果</p>
        <p>* 可以直接按照以下格式组装所需的API链接:</p>
        <p class="interface">
          http://proxy-api.dobel.cn:8100/api/getip?account=XX&accountKey=XX&num=1&only=1&pw=no&protocol=1&type=1&province=0&city=0
        </p>
        <!--<p>* 获取余额接口:</p>
        <p class="interface">
          https://wapi.http.linkudp.com/index/index/get_my_balance?neek=XX&appkey=XX
        </p>-->
        <p>* 添加白名单接口:</p>
        <p class="interface">
          http://proxy-api.dobel.cn:8100/api/save_iplist?account=XX&accountKey=XX&ip=您的ip
        </p>
        <p>* 删除白名单接口:</p>
        <p class="interface">
          http://proxy-api.dobel.cn:8100/api/remove_iplist?account=XX&accountKey=XX&ip=您的ip
        </p>
      </div>
    </div>

    <!--<div class="item">
      <p class="title">用户接入多贝HTTP代码demo</p>
      <div class="item-list">
        <ul class="d-flex d-flex-fw-w">
          <li
            class="d-flex d-flex-aic d-flex-jc-c d-flex-fdc"
            v-for="(item, index) in itemLink"
            :key="index"
          >
            <p>{{ item.title }}</p>
            <p>{{ item.desc }}</p>
            <a href="">点此下载</a>
          </li>
        </ul>
      </div>
    </div>-->
  </div>
</template>

<script>
import JsonViewer from "vue-json-viewer";
import slider from "@/components/slider";
import { provinceAndCityData } from "@/utils/small_city";
import Clipboard from "clipboard";
export default {
  data() {
    return {
      count: 1,
      province: provinceAndCityData,
      provinceValue: "0",
      cityValue: "0",
      isProvince: 1,
      isCity: 2,
      chooseArea: [],
      city: [],
      getIpUrl: "",
      ipxySocks: false,
      agree: false,
      show: true,
      copySuccess: false,
      sliderParam: {
        min: 1,
        max: 200,
      },
      params: {
        ipxy: 1,
        wdsc: 0,
        sjgs: 2,
        fgf: 0,
        dkws: 0,
        ipqc: 0,
        yys: 0,
        pw: "no",
      },
      ipxy: [
        { id: 1, text: "HTTP" },
        { id: 2, text: "SOCKS5" },
      ],
      wdsc: [
        { id: 0, text: "05分钟至25分钟套餐包（0.048元/IP）" },
        { id: 1, text: "25分钟至03小时套餐包（0.12元/IP）" },
        { id: 2, text: "03小时至06小时套餐包（0.24元/IP）" },
      ],
      sjgs: [
        { id: 2, text: "JSON" },
        { id: 1, text: "TXT" },
      ],
      fgf: [
        { id: 0, text: "回车换行(\\r\\n)" },
      ],
      dkws: [
        { id: 0, text: "4位端口" },
        { id: 1, text: "5位端口" },
        { id: 2, text: "端口位数随机" },
      ],
      ipqc: [
        { id: 1, text: "当日去重" },
        { id: 0, text: "不去重" },
      ],
      yys: [
        { id: 0, text: "不限" },
        { id: 1, text: "联通" },
        { id: 2, text: "电信" },
      ],
      pw: [
        { id: 0, text: "白名单", value: "no" },
        { id: 1, text: "账密", value: "yes" },
      ],
      jsonData: {
        count: "1",
        status: "0",
        list: [
          {
            ip: "116.235.53.95",
            sever: "180.118.218.254",
            port: 35055,
            net_type: 1,
            province: "上海",
            city: "上海",
          },
        ],
      },
      fieldsParams: [
        { key: "name", label: "名称" },
        { key: "type", label: "类型" },
        { key: "choose", label: "必选" },
        { key: "message", label: "说明" },
      ],
      itemsParams: [
        {
          isActive: true,
          name: "num",
          type: "int",
          choose: "是",
          message: "提取IP数量，最多200个",
        },
        {
          isActive: true,
          name: "protocol",
          type: "int",
          choose: "否",
          message: "1:http 2:SOCKS5 (默认为 http)",
        },
        {
          isActive: false,
          name: "type",
          type: "int",
          choose: "否",
          message: "数据格式：1:TXT 2:JSON (默认为 json)",
        },
        {
          isActive: false,
          name: "province",
          type: "int",
          choose: "否",
          message: "省份，默认全国随机",
        },
        {
          isActive: true,
          name: "city",
          type: "int",
          choose: "否",
          message: "城市，默认全国随机",
        },
        {
          isActive: false,
          name: "pw",
          type: "string",
          choose: "否",
          message: "no:IP白名单 yes:账密 (默认为 IP白名单)",
        },
        {
          isActive: true,
          name: "only",
          type: "int",
          choose: "否",
          message: "0:不去重 1:当日去重 (默认为 不去重)",
        },
      ],
      fieldsNote: [
        { key: "name", label: "名称" },
        { key: "type", label: "类型" },
        { key: "message", label: "说明" },
      ],
      itemsNote: [
        {
          isActive: true,
          name: "code",
          type: "int",
          message: "错误编码",
        },
        {
          isActive: true,
          name: "status",
          type: "string",
          message: "0为成功，其它为失败",
        },
        {
          isActive: false,
          name: "count",
          type: "string",
          message: "返回IP数量",
        },
        {
          isActive: true,
          name: "info",
          type: "string",
          message: "错误信息描述",
        },
        {
          isActive: false,
          name: "list",
          type: "string",
          message: "服务器列表",
        },
        {
          isActive: true,
          name: "ip",
          type: "string",
          message: "目标IP",
        },
        {
          isActive: false,
          name: "sever",
          type: "string",
          message: "代理服务器的IP",
        },
        {
          isActive: true,
          name: "port",
          type: "int",
          message: "代理服务器端口",
        },
        {
          isActive: false,
          name: "net_type",
          type: "int",
          message: "运营商类型，1:电信 2:移动 3:联通 4:未知",
        },
      ],
      fieldsCode: [
        { key: "code", label: "错误编码" },
        { key: "tip", label: "错误提示" },
        { key: "message", label: "说明" },
      ],
      itemsCode: [
        {
          isActive: true,
          code: "code：201",
          tip: "参数错误",
          message: "请检查请求参数",
        },
        {
          isActive: false,
          code: "code：202",
          tip: "账号验证错误",
          message: "请检查账密是否正确",
        },
        {
          isActive: false,
          code: "code：207",
          tip: "已用完购买的提取量",
          message: "账号内IP数量已消耗完毕",
        },
        {
          isActive: true,
          code: "code：208",
          tip: "服务错误，请重试",
          message: "",
        },
        {
          isActive: true,
          code: "code：429",
          tip: "提取太频繁了，请稍后再试",
          message: "请等待一段时间后重试",
        },
      ],
      itemLink: [
        { title: "C语言", desc: "用户接入多贝HTTP代码demo" },
        { title: "GO语言", desc: "用户接入多贝HTTP代码demo" },
        { title: "Phantomjs语言", desc: "用户接入多贝HTTP代码demo" },
        { title: "Php语言", desc: "用户接入多贝HTTP代码demo" },
        { title: "Java语言", desc: "用户接入多贝HTTP代码demo" },
        { title: "Python语言", desc: "用户接入多贝HTTP代码demo" },
        { title: "Selenium语言", desc: "用户接入多贝HTTP代码demo" },
        { title: "易语言", desc: "用户接入多贝HTTP代码demo" },
        { title: "C#语言", desc: "用户接入多贝HTTP代码demo" },
        { title: "Node语言", desc: "用户接入多贝HTTP代码demo" },
      ],
    };
  },
  components: {
    JsonViewer,
    slider,
  },
  watch: {
    agree: {
      handler: function (val) {
        this.show = !val;
      },
    },
  },
  methods: {
    provinceChange(e) {
      let { value } = e.target;
      this.city = value
        ? this.province.find((v) => v.value === value).children
        : [];
    },
    formChange(attr, index) {
      this.params[attr] = index;
      // console.log(this.params)
    },
    inputData(data) {
      this.count = data;
    },
    countChange(e) {
      this.count = e.target.value.replace(/[^\d]/g, "");
      if (this.count !== "") {
        this.count = this.count > this.sliderParam.max ? 0 : parseInt(this.count)
      } else {
        this.count = 0;
      }
    },
    inputChange(attr) {
      let count = Number(this.count);
      if (attr == "del") {
        if (count <= 0) return;
        this.count--;
      } else {
        if (count >= this.sliderParam.max) return;
        this.count++;
      }
    },
    generateGetIpLink() {
      if (!this.agree) {
        return
      }

      if (!this.chooseArea.includes(1)) {
        this.provinceValue = ''
      }
      if (!this.chooseArea.includes(2)) {
        this.cityValue = ''
      }

      this.getIpUrl =
        "http://proxy-api.dobel.cn:8100/api/getip?account=&accountKey=&num=" +
        this.count +
        "&protocol=" +
        this.params.ipxy +
        "&type=" +
        this.params.sjgs +
        "&pw=" +
        this.params.pw +
        "&only=" +
        this.params.ipqc +
        "&province=" +
        this.provinceValue +
        "&city=" +
        this.cityValue;
    },
    openLink() {
      if (this.getIpUrl !== "") {
        window.open(this.getIpUrl);
      }
    },
    copyUrl() {
      let clipboard = new Clipboard("#copy-link-btn");
      clipboard.on("success", (e) => {
        this.copySuccess = true;
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.copySuccess = false;
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>

<style lang="less">
.tqip {
  padding: 48px 0 64px;
  .title {
    font-weight: bold;
    font-size: 24px;
    color: #000;
  }
  .form {
    margin-bottom: 88px;
    .group {
      margin-bottom: 50px;
      label {
        width: 160px;
        font-size: 19px;
        color: #000;
        font-weight: bold;
        margin: 0;
      }
      span {
        margin: 0;
        font-size: 14px;
        color: #333;
        font-weight: bold;
      }
      .group-right {
        width: calc(100% - 160px);
        input {
          &.tqlx {
            width: 688px;
            line-height: 38px;
            background: #f2f8f4;
            border: 1px solid #b2e3c2;
            border-radius: 6px;
          }
        }
        button {
          outline: none;
          border: none;
          &.btn1 {
            background: #1da83b;
            width: 172px;
            line-height: 40px;
            border-radius: 6px;
            font-size: 18px;
            color: #fff;
            margin-left: 49px;
          }
        }
        .group-item {
          width: 22%;
          position: relative;
          input[type="radio"] {
            appearance: none;
            content: "";
            display: inline-block;
            width: 20px;
            height: 20px;
            margin-right: 10px;
            border: 2px solid #bbe6c9;
            border-radius: 50%;
            vertical-align: middle;
            position: relative;
          }
          input[type="radio"]:checked:before {
            content: "";
            display: inline-block;
            width: 10px;
            height: 10px;
            background-color: #1da83b;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            border-radius: 50%;
          }
          label {
            margin: 0;
            font-size: 18px;
            font-weight: normal;
            width: auto;
          }
          input {
            &.other {
              border: none;
              width: 134px;
              border-bottom: 1px solid #1da83b;
            }
          }
          select {
            width: 212px;
            height: 50px;
            border: 1px solid #1da83b;
            font-size: 18px;
            color: #666;
            outline: none;
          }
          .group-form {
            position: absolute;
            right: -279px;
            top: -80px;
            width: 304px;
            height: 189px;
            background: url("../../assets/images/form.png") center center
              no-repeat;
            .group-form-box {
              padding: 24px 29px 24px 36px;
              .row {
                margin: 0;
                margin-bottom: 12px;
                label {
                  width: 59px;
                  font-size: 16px;
                  color: #000;
                }
                input {
                  width: 176px;
                  line-height: 36px;
                  border: 1px solid #bbe6c9;
                  border-radius: 6px;
                }
              }
              button {
                font-size: 18px;
                color: #fff;
                width: 239px;
                line-height: 25px;
                background: #1da83b;
                border-radius: 6px;
              }
            }
          }
        }
        &.group-right-more {
          .group-item {
            margin-bottom: 30px;
            &:last-of-type {
              width: 50%;
            }
          }
        }
        &.group-right-wdsc {
          .group-item {
            width: 50%;
            margin-bottom: 30px;
          }
        }
        &.group-right-dqxz {
          .group-item {
            &:nth-of-type(2) {
              width: 40%;
            }
            &:last-of-type {
              width: 100%;
              select {
                margin-right: 26px;
              }
            }
            margin-bottom: 20px;
          }
        }
        .progress-box {
          width: calc(100% - 170px);
        }
        .group-count {
          width: 137px;
          line-height: 29px;
          height: 31px;
          border: 1px solid #b2e3c2;
          img {
            width: 27px;
            margin-top: -5px;
            cursor: pointer;
          }
          input {
            border: none;
            border-left: 1px solid #b2e3c2;
            border-right: 1px solid #b2e3c2;
            width: 81px;
            text-align: center;
            font-size: 18px;
            color: #000;
            line-height: 29px;
            height: 29px;
            outline: none;
          }
        }
      }
      a {
        font-size: 18px;
        color: #1da83b;
      }
      .red {
        color: #fe0101;
      }
      .group-agree {
        font-size: 18px;
        color: #000;
        position: relative;
        input {
          margin-right: 13px;
        }
        input[type="checkbox"]::after {
          width: 20px;
          height: 20px;
          content: " ";
          color: #fff;
          display: inline-block;
          visibility: visible;
          box-sizing: border-box;
          background-color: #fff;
          border: 1px solid #1da83b;
          position: absolute;
          top: 4px;
          left: -2px;
        }
        input[type="checkbox"]:checked::after {
          text-align: center;
          content: "√";
          cursor: pointer;
          color: #fff;
          font-size: 14px;
          font-weight: 700;
          background-color: #1da83b;
        }
      }
      button {
        outline: none;
        border: none;
        &.send {
          display: block;
          width: 246px;
          line-height: 76px;
          background-color: #1da83b;
          border-radius: 6px;
          font-size: 18px;
          color: #fff;
          margin-top: 28px;
        }
      }
      .zhgk-list {
        position: relative;
        margin-top: 34px;
        padding: 16px;
        background: #f2f8f4;
        border: 1px solid #b2e3c2;
        border-radius: 6px;
        &::before {
          content: "";
          position: absolute;
          top: 45px;
          left: 48%;
          width: 1px;
          height: 70px;
          background: #b2e3c2;
        }
        .zhgk-list-info {
          width: 50%;
          p {
            &:nth-of-type(1) {
              font-size: 14px;
              color: #000;
            }
            &:nth-of-type(2) {
              font-size: 36px;
              color: #1da83b;
              margin-left: 10px;
            }
          }
        }
        button {
          position: absolute;
          right: 16px;
          bottom: 14px;
          width: 105px;
          line-height: 32px;
          background: #f78834;
          border: none;
          border-radius: 6px;
          font-size: 16px;
          color: #fff;
        }
      }
    }
  }
  .ip {
    margin-bottom: 26px;
    .title {
      img {
        margin-left: 6px;
      }
      span {
        margin: 0;
        font-size: 18px;
        font-weight: normal;
        word-break: break-word;
      }
    }
    .ip-info {
      input {
        width: calc(100% - 309px);
        border: 1px solid #d9e4da;
        border-right: none;
        padding: 0 20px;
      }
      span {
        cursor: pointer;
        text-align: center;
        display: block;
        background: #f2f8f4;
        border: 1px solid #1da83b;
        width: 151px;
        line-height: 63px;
        font-size: 18px;
        color: #1da83b;
        &:nth-of-type(1) {
          margin-right: 5px;
        }
      }
    }
    .item {
      .item-result,
      .result-note {
        border-top: none;
      }
    }
  }
  .item {
    margin-bottom: 102px;
    .item-result {
      border: 1px solid #d9e4da;
      .result-json {
        margin: 33px 45px;
        background: #f2f8f4;
        padding: 46px 34px;
      }
      .result-note,
      .result-code {
        border-top: 1px solid #d9e4da;
        p {
          padding: 26px 0 0 46px;
          font-size: 20px;
          color: #000;
        }
        .table {
          th,
          td {
            border: none !important;
            padding-left: 90px;
          }
        }
        .table-striped tbody tr:nth-of-type(odd) {
          background-color: #f2f8f4;
        }
      }
    }
    .use-way {
      padding: 30px 28px;
      p {
        font-size: 18px;
        color: #000;
        margin: 0;
        line-height: 36px;
        word-break: break-word;
        &.interface {
          color: #1da83b;
        }
      }
    }
    .item-list {
      padding: 27px 30px;
      border: 1px solid #d9e4da;
      ul {
        li {
          width: 257px;
          height: 156px;
          background: #f2f8f4;
          margin-right: 36px;
          margin-bottom: 24px;
          p {
            &:nth-of-type(1) {
              font-size: 18px;
              color: #000;
              font-weight: bold;
            }
            &:nth-of-type(2) {
              font-size: 14px;
              color: #666;
            }
          }
          a {
            font-size: 16px;
            color: #fff;
            width: 110px;
            line-height: 36px;
            background: #1da83b;
            border-radius: 6px;
            text-align: center;
          }
          &:nth-of-type(4n) {
            margin-right: 0;
          }
          &:nth-of-type(9),
          &:nth-of-type(10),
          &:nth-of-type(11),
          &:nth-of-type(12) {
            margin-bottom: 0;
          }
          &:hover {
            box-shadow: 0 2px 16px 2px #f2f8f4;
            a {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 1300px) {
  .tqip .item .item-list {
    padding: 1%;
  }
  .tqip .item .item-list ul li {
    width: 24%;
  }
  .tqip .item .item-list ul li {
    margin-right: 1.3%;
    margin-bottom: 1.3%;
  }
}
@media (max-width: 1200px) {
  .tqip .form .group {
    flex-wrap: wrap;
  }
  .tqip .form .group label {
    display: block;
    width: auto;
    margin-bottom: 2%;
  }
  .tqip .form .group .group-right .group-item label {
    display: inline-block;
  }
  .tqip .form .group .group-right {
    width: 100%;
  }
  .tqip .form .group .group-right .group-item {
    width: 25%;
  }
  .tqip .form,
  .tqip .item {
    margin-bottom: 4%;
  }
}
@media (max-width: 1024px) {
  .tqip .form .group .group-right input.tqlx {
    width: 100%;
  }
  .tqip .form .group .group-right button.btn1 {
    margin-left: 0;
    margin-top: 1%;
    display: block;
  }
  .ip-info {
    flex-wrap: wrap;
  }
  .tqip .ip .ip-info input {
    width: 100%;
    line-height: 50px;
    border-right: 1px solid #d9e4da;
  }
  .tqip .ip .ip-info span {
    width: 49%;
    line-height: 50px;
  }
  .tqip .ip .ip-info span:nth-of-type(1) {
    margin-right: 2%;
  }
  .tqip .item .item-result .result-note p,
  .tqip .item .item-result .result-code p {
    padding: 2% 0 0 2%;
  }
  .tqip .item .item-result .result-json {
    padding: 2%;
    margin: 0;
  }
  .tqip .item .use-way {
    padding: 2%;
  }
  .tqip .item .item-list ul li {
    width: 32%;
    margin-right: 2% !important;
    margin-bottom: 2%;
  }
  .tqip .item .item-list ul li:nth-of-type(3n) {
    margin-right: 0 !important;
  }
}
@media (max-width: 768px) {
  .popover.b-popover {
    display: none;
  }
  .tqip {
    padding: 4% 0;
  }
  .tqip .form .group {
    margin-bottom: 4%;
  }
  .tqip .form .group .zhgk-list {
    margin-top: 3%;
  }
  .tqip .title {
    font-size: 16px;
  }
  .tqip .form .group label,
  .tqip .title,
  .tqip .ip .title span,
  .tqip .ip .ip-info input,
  .tqip .ip .ip-info span,
  .tqip .item .item-result .result-note p,
  .tqip .item .item-result .result-code p,
  .tqip .item .use-way p,
  .tqip .item .item-list ul li p:nth-of-type(1),
  .tqip .form .group .group-right button.btn1,
  .tqip .form .group .zhgk-list button,
  .tqip .form .group .group-right .group-item label,
  .tqip .form .group a,
  .tqip .form .group .group-agree,
  .tqip .form .group .group-right .group-item select,
  .table th,
  .table td,
  .tqip .item .item-list ul li a {
    font-size: 14px;
  }
  .tqip .form .group span {
    font-size: 12px;
  }
  .tqip .form .group .zhgk-list .zhgk-list-info p:nth-of-type(2) {
    font-size: 24px;
  }
  .tqip .form .group button.send {
    font-size: 14px;
    line-height: 60px;
  }
  .tqip .item .item-result .result-note .table th,
  .tqip .item .item-result .result-code .table th,
  .tqip .item .item-result .result-note .table td,
  .tqip .item .item-result .result-code .table td {
    padding-left: 1%;
  }
  .tqip .item .item-list ul li {
    width: 49%;
    margin-right: 2% !important;
    margin-bottom: 2%;
  }
  .tqip .item .item-list ul li:nth-of-type(3n) {
    margin-right: 2% !important;
  }
  .tqip .item .item-list ul li:nth-of-type(2n) {
    margin-right: 0 !important;
  }
}
@media (max-width: 640px) {
  .tqip .form .group .group-right {
    flex-direction: column;
  }
  .tqip .form .group .group-right .progress-box {
    margin-top: 2%;
    width: 100%;
  }
  .tqip .form .group .group-right .group-count {
    margin-top: 2%;
  }
  .tqip .form .group .group-right .group-item,
  .tqip .form .group .group-right.group-right-dqxz .group-item:nth-of-type(2),
  .tqip .form .group .zhgk-list .zhgk-list-info,
  .tqip .ip .title span {
    width: 100%;
  }
  .tqip .form .group .group-right .group-item,
  .tqip .form .group .group-right.group-right-wdsc .group-item,
  .tqip .form .group .group-right.group-right-more .group-item,
  .tqip .form .group .group-right.group-right-dqxz .group-item {
    margin-bottom: 8px;
  }
  .tqip .form .group .group-right .group-item select {
    width: 48%;
    height: 36px;
    font-size: 14px;
  }
  .tqip .form .group button.send {
    line-height: 40px;
    margin: 2% 0;
    width: 100%;
  }
  .tqip .ip .ip-info input,
  .tqip .ip .ip-info span {
    line-height: 40px;
  }
  .tqip
    .form
    .group
    .group-right.group-right-dqxz
    .group-item:last-of-type
    select {
    margin-right: 2%;
  }
  .tqip .form .group .zhgk-list {
    flex-direction: column;
  }
  .tqip .form .group .zhgk-list::before {
    background: transparent;
  }
  .tqip .form .group .zhgk-list .zhgk-list-info {
    display: flex;
    align-items: center;
  }
  .tqip .title {
    flex-wrap: wrap;
  }
}
@media (max-width: 475px) {
  .tqip .item .item-list ul li {
    width: 100%;
    margin-right: 0 !important;
  }
  .tqip .item .item-list ul li:nth-of-type(3n) {
    margin-right: 0 !important;
  }
}
</style>
